angular.module('qkr').factory('businessService', ($http, appConfig) => ({

        updateBusiness(form) {
            const updateCommand = {timezone: {id: form.supportedTimeZone.id}, currency: {id: form.currencyId}, contactDetails: form.contactDetails};
            return $http.post(appConfig.apiUrl + 'merchant/updateBusiness', updateCommand);
        }
    }));



// WEBPACK FOOTER //
// ./src/services/business.services.js